(() => {
  const STYLE_ID = 'dobi-forms-input-label-y-transform';
  const STYLE_VALUE = '-10px';
  const STYLE_RULE = [
    `:host{--input-label-Y-transform:${STYLE_VALUE}!important}`,
    'label[class^="_formInputFieldLabel"]{top:16px!important}'
  ].join('');
  const observedShadowRoots = new WeakSet();
  let applying = false;

  window.formStyles || (window.formStyles = new Map());
  window.formStyles.set(STYLE_ID, STYLE_RULE);

  const applyToEmbed = (embed) => {
    // Inline on the host survives shadow re-renders and beats :host stylesheet rules.
    if (embed.style.getPropertyValue('--input-label-Y-transform') !== STYLE_VALUE) {
      embed.style.setProperty('--input-label-Y-transform', STYLE_VALUE);
    }

    const shadowRoot = embed.shadowRoot;
    if (!shadowRoot) return;

    let style = shadowRoot.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = STYLE_RULE;
      shadowRoot.appendChild(style);
    } else if (style.textContent !== STYLE_RULE) {
      style.textContent = STYLE_RULE;
    } else if (shadowRoot.lastElementChild !== style) {
      // Forms rebuilt styles after ours — move ours back to the end.
      shadowRoot.appendChild(style);
    }

    if (!observedShadowRoots.has(shadowRoot)) {
      observedShadowRoots.add(shadowRoot);
      observer.observe(shadowRoot, { childList: true, subtree: true });
    }
  };

  const applyAll = () => {
    if (applying) return;
    applying = true;
    try {
      document.querySelectorAll('shopify-forms-embed').forEach(applyToEmbed);
    } finally {
      queueMicrotask(() => {
        applying = false;
      });
    }
  };

  const observer = new MutationObserver(applyAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }
})();
